export default {
    type: 'panel',
    name: 'faq',
    blocks: [
        {
            name: 'title', // name or id; MUST be unique
            label: 'Titre',
            max: 1, // max same items allowed
            type: 'text',
        },
        {
            name: 'questions', // repeatable question / answer pairs
            label: 'Questions',
            type: 'mixed', // mixed (with children)
            blocks: [
                {
                    name: 'question',
                    label: 'Question',
                    max: 1,
                    type: 'text', // plain text => reused as the JSON-LD Question name
                },
                {
                    name: 'answer',
                    label: 'Réponse',
                    max: 1,
                    type: 'html', // rich answer
                },
            ],
        },
    ],
};
